import { render } from "./App.vue?vue&type=template&id=b640e1e2&lang=pug"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b640e1e2&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__